import { render } from "./TrailerDetails.vue?vue&type=template&id=e8af1028&scoped=true"
import script from "./TrailerDetails.vue?vue&type=script&lang=js"
export * from "./TrailerDetails.vue?vue&type=script&lang=js"

import "./TrailerDetails.vue?vue&type=style&index=0&id=e8af1028&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8af1028"]])

export default __exports__